// ═══════════════════════════════════════════════════════════
// V·IAnet Governance — Catálogo de Módulos y Bloques
// Fuente única de verdad para toda la plataforma.
// ═══════════════════════════════════════════════════════════

export const ALL_MODULES = [
  { code: 'M1', name: 'V·IAnet Structure', description: 'Organigramas Interactivos' },
  { code: 'M2', name: 'V·IAnet Process', description: 'Mapa de Procesos' },
  { code: 'M3', name: 'V·IAnet Flow', description: 'Flujogramas' },
  { code: 'M4', name: 'V·IAnet Docs', description: 'Gestión Documental' },
  { code: 'M5', name: 'V·IAnet Search', description: 'Búsqueda Inteligente' },
  { code: 'M6', name: 'V·IAnet Versions', description: 'Control de Versiones y Aprobación' },
  { code: 'M7', name: 'V·IAnet Audit', description: 'Auditoría' },
  { code: 'M8', name: 'V·IAnet Admin', description: 'Administración y RBAC' },
  { code: 'M9', name: 'V·IAnet AI API', description: 'API de Inteligencia Artificial' },
  { code: 'M10', name: 'V·IAnet Assistant', description: 'Asistente Virtual de Gobernanza' },
  { code: 'M11', name: 'V·IAnet Dashboard', description: 'Cuadros de Mando de Gobernanza' },
  { code: 'M12', name: 'V·IAnet Apps', description: 'Apps de Digitalización de Procesos' },
  { code: 'M13', name: 'V·IAnet News', description: 'Comunicación Interna' },
  { code: 'M14', name: 'V·IAnet Mobile', description: 'Aplicación Móvil' },
  { code: 'M15', name: 'V·IAnet Sign', description: 'Firma Electrónica' },
  { code: 'M16', name: 'V·IAnet Requests', description: 'Solicitudes y Aprobaciones' },
  { code: 'M17', name: 'V·IAnet Notify', description: 'Notificaciones Multi-canal' },
  { code: 'M18', name: 'V·IAnet i18n', description: 'Soporte Multilingüe' },
  {
    code: 'M19',
    name: 'V·IAnet Risk',
    description: 'Gestión de Riesgos Corporativos ISO 31000',
    estado: 'PREVISTO' as const,
  },
  {
    code: 'M20',
    name: 'V·IAnet Support',
    description: 'Helpdesk y Soporte Interno',
    estado: 'PREVISTO' as const,
  },
] as const;

export type ModuleCode = (typeof ALL_MODULES)[number]['code'];

/** Mapeo bloque de ingeniería → módulos que lo componen */
export const BLOQUE_MODULOS: Record<string, ModuleCode[]> = {
  STRUCTURE: ['M1'],
  PROCESS: ['M2', 'M3'],
  INFORMATION: ['M4', 'M5', 'M6'],
  COMPLIANCE: ['M7', 'M19'],
  TECH: ['M12', 'M16', 'M20'],
  REPUTATION: ['M13'],
};

/** Módulos transversales: siempre visibles si están activos, no pertenecen a un bloque */
export const MODULOS_TRANSVERSALES: ModuleCode[] = ['M8', 'M9', 'M10', 'M11'];

/** Módulos incluidos por plan de licencia */
export const PLAN_MODULOS: Record<string, ModuleCode[]> = {
  BASIC: ['M4', 'M8'],
  PROFESSIONAL: ['M1', 'M2', 'M3', 'M4', 'M5', 'M6', 'M7', 'M8', 'M11'],
  ENTERPRISE: ['M1', 'M2', 'M3', 'M4', 'M5', 'M6', 'M7', 'M8', 'M9', 'M10', 'M11', 'M12', 'M16'],
  PREMIUM: [
    'M1',
    'M2',
    'M3',
    'M4',
    'M5',
    'M6',
    'M7',
    'M8',
    'M9',
    'M10',
    'M11',
    'M12',
    'M13',
    'M16',
  ],
};

/** Cadena de dependencia: para activar un bloque, sus dependencias deben estar activas */
export const DEPENDENCIAS_BLOQUE: Record<string, string[]> = {
  STRUCTURE: [],
  PROCESS: ['STRUCTURE'],
  INFORMATION: ['PROCESS'],
  COMPLIANCE: ['INFORMATION'],
  TECH: [],
  REPUTATION: [],
};

/** Mapeo ruta → módulo requerido (para RouteGuard) */
export const RUTA_MODULO: Record<string, ModuleCode> = {
  '/structure/organigrama': 'M1',
  '/structure/organizaciones': 'M1',
  '/structure/gobernanza': 'M1',
  '/process/explorador': 'M2',
  '/process/mapa': 'M2',
  '/information/auditoria': 'M7',
  '/structure/personas': 'M1',
  '/admin/settings': 'M8',
  '/admin/importar': 'M4',
};

/** Helper: ¿el bloque tiene al menos un módulo activo? */
export function bloqueActivo(bloque: string, modulosActivos: string[]): boolean {
  const modulos = BLOQUE_MODULOS[bloque];
  if (!modulos) return false;
  return modulos.some((m) => modulosActivos.includes(m));
}
